import { render, staticRenderFns } from "./routingSettings.vue?vue&type=template&id=e4c09386&scoped=true&"
import script from "./routingSettings.vue?vue&type=script&lang=js&"
export * from "./routingSettings.vue?vue&type=script&lang=js&"
import style0 from "./routingSettings.vue?vue&type=style&index=0&id=e4c09386&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c09386",
  null
  
)

export default component.exports